import React from 'react';

interface LogoProps {
  light?: boolean;
  className?: string;
}

export const LogoIcon: React.FC<LogoProps> = ({ light = false, className = "h-8 w-auto" }) => (
  <img 
    src={light ? "/logo-icon-white.png" : "/logo-icon.png"} 
    alt="PropertyDirect Icon" 
    className={`object-contain transition-all duration-200 ${className}`} 
  />
);

export const LogoWordmark: React.FC<LogoProps> = ({ light = false, className = "h-6 w-auto" }) => (
  <img 
    src={light ? "/logo-wordmark-white.png" : "/logo-wordmark.png"} 
    alt="PropertyDirect" 
    className={`object-contain transition-all duration-200 transform translate-y-[4%] ${className}`} 
  />
);

interface LogoFullProps {
  light?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const LogoFull: React.FC<LogoFullProps> = ({ 
  light = true, 
  size = 'md', 
  className = "" 
}) => {
  const iconSizes = {
    sm: "h-[28px]",
    md: "h-[36px]",
    lg: "h-[50px]"
  };
  const wordmarkSizes = {
    sm: "h-[16px]",
    md: "h-[22px]",
    lg: "h-[30px]"
  };
  const taglineSizes = {
    sm: "text-[8px] mt-[1.5px]",
    md: "text-[9.5px] mt-[2.5px]",
    lg: "text-[13px] mt-[3.5px]"
  };

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <LogoIcon light={light} className={`${iconSizes[size]} w-auto flex-shrink-0`} />
      <div className="flex flex-col leading-none">
        <LogoWordmark light={light} className={`${wordmarkSizes[size]} w-auto`} />
        <span className={`font-bold tracking-wider whitespace-nowrap ${taglineSizes[size]} ${light ? 'text-white/60' : 'text-slate-500'}`}>
          Smart Billing. Seamless Communication
        </span>
      </div>
    </div>
  );
};


